var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8787 5.70709C14.2692 5.31657 14.9024 5.31657 15.2929 5.70709V5.70709C15.6834 6.09762 15.6834 6.73078 15.2929 7.12131L10.7071 11.7071L15.2929 16.2929C15.6834 16.6834 15.6834 17.3166 15.2929 17.7071V17.7071C14.9024 18.0976 14.2692 18.0976 13.8787 17.7071L7.87868 11.7071L13.8787 5.70709Z",
    fill: "#7956D8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrowIcon);
export default __webpack_public_path__ + "static/media/leftArrowIcon.fbe8a073f198411d8b4a176ff31fdcc0.svg";
export { ForwardRef as ReactComponent };